module.exports = __webpack_public_path__ + "img/startthemusic.7f8922fb.png";